// ═══════════════════════════════════════════════════════════════════════
// data/cpcAllocations.js — cpc_allocations table access.
// ═══════════════════════════════════════════════════════════════════════
// Thin Supabase wrappers for CPC date-range allocation CRUD, mirroring
// data/dailyLogs.js. Each returns the raw Supabase `{ data, error }` so callers
// handle errors themselves. RLS (mirrors daily_logs) is the security boundary.
// Payload columns: workspace_id, channel_id, platform, date_from, date_to,
// cpc_amount (DATE columns as "YYYY-MM-DD").
import { supabase } from "../lib/supabaseClient";

export function insertCpcAllocation(payload) {
  return supabase.from("cpc_allocations").insert(payload).select().single();
}

export function updateCpcAllocation(id, payload) {
  return supabase.from("cpc_allocations").update(payload).eq("id", id);
}

export function deleteCpcAllocation(id) {
  return supabase.from("cpc_allocations").delete().eq("id", id);
}
